import { ClientInstallationStatusEnum } from '@api/enum/client-installation.enum';
import { getAllClientInstallation } from '@api/services/client-installation.service';
import useDataQuery from 'modules/shared/hooks/use-data-query';

type FilterValue = 'ALL' | ClientInstallationStatusEnum;

export const useClientInstallationListData = (params?: { filterValue?: FilterValue }) => {
    const { filterValue = 'ALL' } = params || {};

    const draftClientListQuery = useDataQuery(['client-installations'], () => getAllClientInstallation());

    const filtered = (() => {
        const data = draftClientListQuery.data;
        if (!data?.length) return data;
        if (filterValue === 'ALL') return data;
        return data.filter((r: any) => r.status === filterValue);
    })();

    return {
        clientInstallationListData: filtered,
        isLoading: draftClientListQuery.isLoading,
    };
};
